"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class AbstractFormStore {
    constructor() {
        /**
         * Uses naming convention to speed error handling.
         * If you declare variable name "apple" this function
         * will search for the error variable named as "appleError"
         * and setting this error string variable with an empty string.
         */
        this.cleanSimilarFieldError = (fieldName) => {
            const errorName = fieldName + "Error";
            if (Object.keys(this).includes(errorName)) {
                this[errorName] = null;
            }
        };
        this.handleBooleanToggle = (fieldName) => ((value) => {
            if (!Object.keys(this).includes(fieldName)) {
                throw this.errors.fieldNotFound(fieldName);
            }
            this.cleanSimilarFieldError(fieldName);
            this[fieldName] = value;
        });
        /**
         * Generates a function that will handle the change of a string
         * variable by it's variable name.
         *
         * @example
         * declare in your store
         * someVariable = "";
         *
         * use in your component
         * onChange = (value) => handleChange("someVariable")(value);
         *
         * @param fieldName literal name of the target variable
         * @returns
         * function that will handle the value change and has
         * the new value of the variable as a parameter.
         */
        this.handleChange = (fieldName) => ((text) => {
            if (!Object.keys(this).includes(fieldName)) {
                throw this.errors.fieldNotFound(fieldName);
            }
            this.cleanSimilarFieldError(fieldName);
            this[fieldName] = text;
        });
        /**
         * Generates a function that will handle the change of a string
         * variable by it's variable name from a item of a source list.
         *
         * @example
         * // declare in your store
         * someVariable = SomeEnumType
         * someEnumTypes = [ Enum1, Enum2, Enum3 ]
         *
         * // use in your component
         * onChange = (value) => handleChange("someVariable", "someEnumTypes")(value);
         *
         * @param fieldName literal name of the target variable.
         * @param optionListFieldName literal name of the list of available options.
         *
         * @returns
         * function that will handle the value change and has
         * the new value of the variable as a parameter.
         */
        this.handleEnumPickerChange = (fieldName, optionListFieldName) => ((value) => {
            if (!Object.keys(this).includes(fieldName)) {
                throw this.errors.fieldNotFound(fieldName);
            }
            if (!Object.keys(this).includes(optionListFieldName)) {
                throw this.errors.fieldNotFound(optionListFieldName);
            }
            this.cleanSimilarFieldError(fieldName);
            const foundValue = this[optionListFieldName].find((item) => item);
            if (foundValue) {
                this[fieldName] = value;
            }
        });
        this.errors = {
            fieldNotFound: (fieldName) => ({
                type: "Fatal",
                message: `Store doesn't include variable ${fieldName}`,
            }),
        };
        mobx_1.makeObservable(this, {
            handleChange: mobx_1.action,
            handleBooleanToggle: mobx_1.action,
            handleEnumPickerChange: mobx_1.action,
        });
    }
}
exports.default = AbstractFormStore;
